export default __webpack_public_path__ + "static/media/personal-moneytransfer-icon.a19a22e9.svg";